import CvPresentationNotifications from '../components/CvPresentationNotifications';
import React from "react";
import { ExpiredDocumentsProvider } from "../context/ExpiredDocumentsContext";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../pages/Sidebar";
import "../styles/brand.css";
import ResponsiveTables from "../components/ResponsiveTables";

export default function AppLayout() {
  const location = useLocation();

  return (
    <ExpiredDocumentsProvider><div className="jm-workspace flex h-screen bg-slate-50">
      <ResponsiveTables />
      <Sidebar path={location.pathname} />
      <main className="flex-1 min-w-0 p-3 md:p-6 overflow-y-auto bg-slate-50 w-full">
        <div className="jm-page-shell w-full py-6">
          <CvPresentationNotifications />
          <Outlet />
        </div>
      </main>
    </div></ExpiredDocumentsProvider>
  );
}
